var _path, _path2, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95592 8.04656L4.04364 7.40764C4.25008 5.91018 4.93099 4.52026 5.98482 3.44517C7.03864 2.37009 8.40892 1.66745 9.89129 1.44205C11.3737 1.21664 12.8887 1.48055 14.2104 2.19441C15.5322 2.90827 16.5898 4.03383 17.2256 5.40323C17.8614 6.77263 18.0413 8.31249 17.7384 9.79316C17.4356 11.2738 16.6662 12.616 15.5451 13.6194C14.4239 14.6229 13.0111 15.2339 11.5173 15.3613C10.0235 15.4887 8.5287 15.1257 7.25591 14.3264",
    stroke: "#A1A5B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26343 10.5112L1.54867 5.55649L6.63486 6.61977L3.26343 10.5112Z",
    fill: "#A1A5B7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.84069,
    y1: 5.16511,
    x2: 9.91039,
    y2: 9.61879,
    stroke: "#A1A5B7",
    strokeWidth: 1.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.9,
    x2: 3.96875,
    y2: -0.9,
    transform: "matrix(0.933126 0.35955 -0.354094 0.93521 9.0105 9.63306)",
    stroke: "#A1A5B7",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.32eb77682a8cfef1487e3b4902d33c8e.svg";
export { ForwardRef as ReactComponent };